import Api from "../api";
const basePath = "/FormTask";
export function UpdateRecurrencyToLatestForm(recurrencyid) {
    return Api.post(`${basePath}/recurrency/${recurrencyid}/updateToLatestForm`);
}
export function UpdateTaskToLatestForm(recurrencyid) {
    return Api.post(`${basePath}/${recurrencyid}/updateToLatestForm`);
}
export async function UploadFile(formAnswerId, questionID, filename, blob, taskId) {
    const formData = new FormData();
    formData.append("taskAnswerId", formAnswerId);
    formData.append("formQuestionId", questionID);
    if (taskId) {
        formData.append("formTaskId", taskId);
    }
    formData.append("files", blob, filename);
    let response = await Api.post(`${basePath}/uploadFile`, formData);
    return response.data;
}
export async function GetFile(fileName) {
    const response = await Api.get(`${basePath}/getFile/${fileName}`, {
        responseType: 'blob'
    });
    return response.data;
}
//Por motivos de segurança não estamos mais removendo os arquivos no blob
export async function DeleteFile(formAnswerId, filename) {
    //  const response = await Api.post(`${basePath}/removeFile/${formAnswerId}/${filename}`);
    //  return response.data;
    return true;
}
